import {Deserialize, deserialize} from 'libs/cerialize';

export class CreateEnvironmentModel {
	Name: string;
}